<template lang="pug">
  DefaultLayout(:topMenuItems="topMenuItems" :key="$route.params.companyId")
    router-view()
</template>

<script>
import crmModel from '@/model/crm';

import DefaultLayout from '@/layouts/Default.vue';
import { isVisitedEnough } from '@/utils/newPage';

export default {
  name: 'CompanyDetailPage',
  components: { DefaultLayout },
  data() {
    return {
      // участники воронок CRM, видимые текущему пользователю — для пункта меню CRM
      crmMembers: [],
    };
  },
  created() {
    this.load();
  },
  watch: {
    company(val) {
      document.title = val.name;

      const getter = this.$store.getters['notification/itemIdsByFilter'];
      const notifications = getter({ companyId: val.id });
      // напоминания по заявкам CRM тоже несут companyId, но читаются только в
      // самой заявке (CrmLeadDetailApi) — как уведомления задач на странице проекта
      notifications
        .filter(n => !n.info.leadId)
        .forEach(n => this.$store.dispatch('notification/view', n));
    },
    '$route.params.companyId': function () {
      this.load();
    },
  },
  computed: {
    company() { return this.$store.getters['company/withMembers']; },
    deputies() { return this.company.deputies ?? [] },
    isOwner() { return this.company?.owner?.id === this.currUser.id },
    isDeputy() { return this.deputies.find(e => e.user.id === this.currUser.id) },
    hasCrmAccess() { return crmModel.canAccess(this.company, this.currUser, this.crmMembers); },
    currUser() { return this.$store.state.auth.user; },
    err403() { return this.$store.getters['error/err403']; },
    topMenuItems() {
      if (this.err403) return null;

      const items = [];

      items.push({ label: 'Отделы',      to: { name: 'company-departments'  }   }); // eslint-disable-line

      if (this.isOwner || this.isDeputy) {
        items.push({ label: 'Сотрудники',  to: { name: 'company-employees'    },  }); // eslint-disable-line
        items.push({ label: 'Настройки',   to: { name: 'company-description'  },  }); // eslint-disable-line
      }

      if (this.hasCrmAccess) {
        items.push({ label: 'CRM',         to: { name: 'crm'                  }, isNewLabel: !isVisitedEnough('crm')  }); // eslint-disable-line
      }

      items.push({ label: 'Права пользователей',   to: { name: 'company-access-description'  },  }); // eslint-disable-line

      //const extendedAccess = this.access.isProjectAuthor?.() || this.access.isProjectAdmin?.();
      return items//.filter(i => extendedAccess || !i.admin);
    },
  },
  methods: {
    async load() {
      const { companyId } = this.$route.params;
      this.$store.dispatch('company/fetch', { companyId, force: true });

      // Неудача здесь не повод для алерта: без ответа пункт CRM просто не
      // показываем, а 403/404 по компании и так уводят страницу в ErrorPage
      this.crmMembers = await crmModel.fetchCompanyMembers(companyId).catch(() => []);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
